import { Component, OnInit, ViewChild, HostListener, Renderer2,ElementRef  } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  selectedItem = 0; 
  activeSlideIndex = 0;  // Inicializa la diapositiva activa
  //@ViewChild('prevButton', { static: true }) prevButton: any;

  ngOnInit(): void {
    // Verifica si los métodos están correctamente enlazados y si los clics se pueden registrar
    document.querySelectorAll('.carousel-control-prev, .carousel-control-next').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault();  // Evita que otros manejadores del evento se ejecuten.
      });
    });
    // console.log("Componente inicializado");
    // nlpr ini
    this.updateMargin();
    // nlpr fin
  }

  ngAfterViewInit() {
    // Verificar si el botón prevButton está disponible
    //console.log(this.prevButton);
    //this.prevButton.nativeElement.addEventListener('click', () => this.moveToPrevSlide());
  }

  onSlideChange(index: number) {
    this.selectedItem = index;
  }

  constructor(
    // nlpr ini
    private renderer: Renderer2,
    private el: ElementRef,
    // nlpr fin
  ) { }

  
  changeSlide(index: number) {
    // console.log("index:"+index);
    this.activeSlideIndex = index;
  }

  // Función para mover al slide anterior
  moveToPrevSlide() {
    // console.log("moveToPrevSlide");
    if (this.activeSlideIndex > 0) {
      this.activeSlideIndex--;
    } else {
      this.activeSlideIndex = 2; // Vuelve al último slide si está en el primero
    }
  }

  // Función para mover al siguiente slide
  moveToNextSlide() {
    // console.log("moveToNextSlide");
    if (this.activeSlideIndex < 2) {
      this.activeSlideIndex++;
    } else {
      this.activeSlideIndex = 0; // Vuelve al primer slide si está en el último
    }
  }

  // nlpr ini
  fixedContainerHeight: number = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateMargin();  // Update height
  }
  private updateMargin(): void {
    setTimeout(() => {
      const fixedContainer = document.querySelector('.fixed-submenus') as HTMLElement;
      if (fixedContainer) {
        this.fixedContainerHeight = fixedContainer.offsetHeight;
        // console.log("tamaniooooooooooooooooo"+this.fixedContainerHeight);
        const contentContainer = this.el.nativeElement.querySelector('.carruselContainer') as HTMLElement;
        if (contentContainer) {
          this.renderer.setStyle(contentContainer, 'margin-top', `${this.fixedContainerHeight}px`);
        }
        const contentContainerM = this.el.nativeElement.querySelector('.carruselContainerM') as HTMLElement;
        if (contentContainerM) {
          this.renderer.setStyle(contentContainerM, 'margin-top', `${this.fixedContainerHeight}px`);
        }
      }
    }, 0); // Retrasar la ejecución hasta el siguiente ciclo de eventos
  }
  // nlpr fin

  
}
